import styles from "./allStatus.module.css";
import { Button } from "@progress/kendo-react-buttons";
import { useCallback, useEffect, useState } from "react";
import { Input, TextArea } from "@progress/kendo-react-inputs";
import { Window } from "@progress/kendo-react-dialogs";
import { useHistory } from "react-router-dom";
import { parseDate } from "../../../com/dateUtil";
import { setUpdateUserNote } from "../../../service/monitor/allStatusService";
import kendo from "@progress/kendo-ui";
import { Grid, GridColumn, GridNoRecords } from "@progress/kendo-react-grid";

import { getUserPattern, setUserPattern } from '../../../service/monitor/allStatusService';
import { getFile } from "../../../service/mngt/elderService";
import { getLocation } from "../../../service/log/locationLogService";
import { ElderInfoWindow } from '../installStatus/elderInfoWindow';
import { numFormat } from './../../../com/dataUtil';

const AllStatusItem = ({ conn, item, map, setSelectUser, mapContainer, setMapType, setUserInfoState, setDataSource, getGridData, currentLocation, setCurrentLocation}) => {

  const history = useHistory();

  const [dataItem, setDataItem] = useState({
    address: null,
    birthday: null,
    bizType: null,
    cid: null,
    dangerElderYn: null,
    dataStatSctCodeNo: null,
    dataStatTerm: null,
    rgnCode: null,
    rgnTermSimple: null,
    dongCode: "4413110200",
    dongTerm: "충청남도 천안시 동남구 성황동",
    dongTermSimple: "성황동",
    temperature: null,
    humidity: null,
    co2: null,
    tvoc: null,
    light: null,
    lat: null,
    latestDataStatTime: null,
    latestGathDtm: null,
    liveType: null,
    lng: null,
    managerId: null,
    managerPhone: null,
    managerTerm: null,
    meainStatCode: null,
    meainStatTerm: null,
    movement: null,
    nickName: null,
    note: null,
    pattern : null,
    protectorPhone: null,
    protectorTerm: null,
    regiDtm: null,
    respiratoryRate: null,
    sickType: null,
    userGender: null,
    userId: null,
    userPhone: null,
    userTerm: null,
    userTypeCode: null,
    waveSignal: null,
    weekDangerCnt: null,
    weekOffCnt: null,
    weekWarnCnt: null,
    dangerYn: null,
    fileIdUserPhoto: null,
    fileIdPlacePhoto1: null,
    fileIdPlacePhoto2: null,
    fileIdPlacePhoto3: null,
    imgFileUserPhoto: null,
    imgFilePlacePhoto1: null,
    imgFilePlacePhoto2: null,
    imgFilePlacePhoto3: null,
    dayofweek: null,
    time: null,
    behaviorCode: null,
    behaviorTerm: null,
    behaviorTermOther: null,
    residenceStatus: null,
  });

  const cid = dataItem.cid;
  const rgnCode = dataItem.rgnCode;
  const rgnTermSimple = dataItem.rgnTermSimple;
  const dongCode = dataItem.dongCode;
  const dongTermSimple = dataItem.dongTermSimple;
  const elderTerm = dataItem.userTerm;
  const elderId = dataItem.userId;
  const startDtm = new Date();
  const endDtm = new Date();
  const radio = "HH";

  const [imgFile, setImgFile] = useState({
    imgFileUserPhoto: "",
    imgFilePlacePhoto1: "",
    imgFilePlacePhoto2: "",
    imgFilePlacePhoto3: "",
  });

  // 대상자 이력 이동
  const elderLogBtnClickEvt = () => {
    history.push({
      pathname: "/log/elder",
      state: { cid, rgnCode, rgnTermSimple, dongCode, dongTermSimple, elderTerm, elderId, startDtm, endDtm, radio },
    });
  };

  // 카카오 적용
  const { kakao } = window;
  
  let defaultMarker;
  let markers;
  let infoWindow;
  let customOverlayLocation;
  let customOverlayBackground;
  let linePath = [];

  // 원 그리기
  const drawCircle = () => {
    const circle = new kakao.maps.Circle({
      center:  new kakao.maps.LatLng(dataItem.lat, dataItem.lng),  // 원의 중심좌표 입니다 
      radius: 1000, // 미터 단위의 원의 반지름입니다 
      strokeWeight: 1, // 선의 두께입니다 
      strokeColor: '#90d0d1', // 선의 색깔입니다
      strokeOpacity: 0, // 선의 불투명도 입니다 1에서 0 사이의 값이며 0에 가까울수록 투명합니다
      strokeStyle: 'dashed', // 선의 스타일 입니다
      fillColor: '#44c7be', // 채우기 색깔입니다
      fillOpacity: 0.4, // 채우기 불투명도 입니다
      // map: map,  
    })      
    // 지도에 원을 표시합니다 
    circle.setMap(map);
  }
  
  // 선 그리기
  const drawLine = () => {
    const polyline = new kakao.maps.Polyline({
      path: linePath,
      strokeWeight: 4,
      strokeColor: '#3d948e',
      strokeOpacity: 0.8,
      strokeStyle: 'solid',
      // map: map,
    });
    // Add the polyline to the map
    polyline.setMap(map);
  }

  // 대상자 위치 마커
  const getUserLocation = () => {
    getLocation(conn, dataItem)
    .then(result => {
      setDataSource(dataSource => {
        const item = { ...dataSource };
        item.locationLogList = result;
        return item;
      })
      const lastIndex = result.length - 1;
      let markersImage = "/images/mobile/marker/marker";
      // 대상자 사진이 있을 때 
      if(dataItem.fileIdUserPhoto) {
        getFile(conn, dataItem.fileIdUserPhoto)
        .then(fileResponse => {
          const dataUri = 'data:image/png;base64,' + fileResponse;
          result.map((item, index) => {
            // const contentLocation = '<div class="customOverlayNumber">' + (lastIndex - (index - 1)).toString() + '</div>'
            // const contentBackground = '<div class="customOverlayNumberBackground"></div>'
            // const position = new kakao.maps.LatLng(item.lat, item.lng);
            // customOverlayBackground = new kakao.maps.CustomOverlay({
            //   position: position,
            //   content: contentBackground,
            //   xAnchor: 0.50,
            //   yAnchor: 0.83
            // });
            // customOverlayBackground.setMap(map);
            // customOverlayLocation = new kakao.maps.CustomOverlay({
            //   position: position,
            //   content: contentLocation,
            //   xAnchor: 0.3,
            //   yAnchor: 0.91
            // });
            // customOverlayLocation.setMap(map);
            markers = new kakao.maps.Marker({
              map: map,
              position: new kakao.maps.LatLng(parseFloat(item.lat), parseFloat(item.lng)),
              zIndex: lastIndex - (index - 1),
              image: index === 0 ?
                  new kakao.maps.MarkerImage(dataUri, new kakao.maps.Size(45, 45))
                  // new kakao.maps.MarkerImage(dataItem.userGender === "M" ? markersImage + "_60_grandfather.png" : markersImage + "_60_grandmother.png", new kakao.maps.Size(60, 60))
                  : new kakao.maps.MarkerImage(markersImage + (lastIndex - (index - 1)) + ".png", new kakao.maps.Size(30, 30))
            })
            if(index === 0) {
              // Change the center of the map
              map.setCenter(new kakao.maps.LatLng(parseFloat(item.lat), parseFloat(item.lng)))
              setCurrentLocation((currentLocation) => {
                const data = { ...currentLocation };
                data.map = map;
                data.lat = item.lat;
                data.lng = item.lng;
                return data;
              })
              
              const contentLocation = '<div class="customOverlayLocation">' + item.address + '</div>'
              const contentBackground = '<div class="customOverlayBackground"></div>'
              const position = new kakao.maps.LatLng(item.lat, item.lng);
              customOverlayLocation = new kakao.maps.CustomOverlay({
                position: position,
                content: contentLocation,
                xAnchor: 0.3,
                yAnchor: 0.91
              });
              customOverlayLocation.setMap(map);
              customOverlayBackground = new kakao.maps.CustomOverlay({
                position: position,
                content: contentBackground,
                xAnchor: 0.50,
                yAnchor: 0.83
              });
              customOverlayBackground.setMap(map);
            }
            // Add marker positions to the polyline points array
            linePath.push(new kakao.maps.LatLng(parseFloat(item.lat), parseFloat(item.lng)));
            drawLine();
          })
        })
        .catch(err => {
          console.log("getFile err = ", err);
        })
      } else {
      // 대상자 사진이 없을 때 
        result.map((item, index) => {
          markers = new kakao.maps.Marker({
            map: map,
            position: new kakao.maps.LatLng(parseFloat(item.lat), parseFloat(item.lng)),
            zIndex: lastIndex - (index - 1),
            image: index === 0 ?
              new kakao.maps.MarkerImage(dataItem.userGender === "M" ? markersImage + "_60_grandfather.png" : markersImage + "_60_grandmother.png", new kakao.maps.Size(60, 60))
              : new kakao.maps.MarkerImage(markersImage + (lastIndex - (index - 1)) + ".png", new kakao.maps.Size(30, 30))
          })
          if(index === 0) {
            // Change the center of the map
            map.setCenter(new kakao.maps.LatLng(parseFloat(item.lat), parseFloat(item.lng)))
            setCurrentLocation((currentLocation) => {
              const data = { ...currentLocation };
              data.map = map;
              data.lat = item.lat;
              data.lng = item.lng;
              return data;
            })

            const content = '<div class="customOverlayLocation">' + item.address + '</div>'
            const position = new kakao.maps.LatLng(item.lat, item.lng);
            customOverlayLocation = new kakao.maps.CustomOverlay({
              position: position,
              content: content,
              xAnchor: 0.3,
              yAnchor: 0.91
            });
            customOverlayLocation.setMap(map);
          }
          // Add marker positions to the polyline points array
          linePath.push(new kakao.maps.LatLng(parseFloat(item.lat), parseFloat(item.lng)));
          drawLine();
        })
      }
    })
    .catch(err => {
      console.log("getLocation err = ", err);
    })
  }
  
  
  // 맵 좌표 요청 (맵 이동)
  const setMapPosition = (lati, longi, map) => {
    map.setCenter(new kakao.maps.LatLng(lati, longi));
  };

  // infoWindow 창 제작
  const createInfoWindow = (map, marker, infowindow, element) => {
    infowindow.open(map, marker);
    //닫기(x) 버튼
    const closeBtn = document.getElementsByName("closeInfoBtn")[0];
    closeBtn.addEventListener("click", function () {
      infowindow.close();
    });

    //특이사항 수정 버튼
    const modifyBtn = document.getElementById("noteModiBtn");
    modifyBtn.addEventListener("click", function () {
      const elderInfoNote = document.getElementById("elderInfoNote");
      const dataItem = {
        userId: elderInfoNote.name,
        note: elderInfoNote.value,
      };
      kendo.confirm("특이사항을 수정하시겠습니까?").then(() => {
        setUpdateUserNote(conn, dataItem)
          .then(response => {
            getGridData();
            kendo.alert("수정완료");
          })
          .catch(error => console.log("특이사항 업데이트 오류", error));
      });
    });
  };

  // 대상자 클릭 시 정보 조회 및 맵 이동
  const findUserInfo = () => {
    setCurrentLocation(undefined);
    setSelectUser(dataItem);
    setMapType("USER");
    setUserInfoState("CLOSE");
    getUserLocation();

    // 맵 설정
    map = new kakao.maps.Map(mapContainer.current, {
      //지도를 생성할 때 필요한 기본 옵션
      center: new kakao.maps.LatLng(dataItem.lat, dataItem.lng), //지도의 중심좌표.
      level: 6, //지도의 레벨(확대, 축소 정도)
    });

    const defaultMarkerImg = "/images/mobile/marker/marker_60_home.png"
    // 대상자 설비 위치 마커 표시
    const markerPosition = new kakao.maps.LatLng(dataItem.lat, dataItem.lng); // Replace with your desired latitude and longitude
    defaultMarker = new kakao.maps.Marker({
      position: markerPosition,
      image: new kakao.maps.MarkerImage(defaultMarkerImg, new kakao.maps.Size(60, 60)),
      // map: map,
    });
    defaultMarker.setMap(map);

    drawCircle();


    // // 마우스 오버 콘텐츠
    // const overWindow = new kakao.maps.InfoWindow({
    //   content: '<div>' + item.userTerm + "</div>",
    // });

    // // 마커 마우스 오버 인 이벤트
    // const mouseOverEvt = () => {
    //   overWindow.open(map, defaultMarker);
    // };

    // kakao.maps.event.addListener(defaultMarker, "mouseover", mouseOverEvt);
    // // 마커 마우스 오버 아웃 이벤트
    // const mouseOutEvt = () => {
    //   overWindow.close();
    // };
    // kakao.maps.event.addListener(defaultMarker, "mouseout", mouseOutEvt);

    // 마커 클릭 콘텐츠
    const infoWindow = new kakao.maps.InfoWindow({
      // position : new kakao.maps.LatLng(elderInfo.lati, elderInfo.longi),
      content: ElderInfoWindow(item),
    });
    infoWindow.setZIndex(10);
    // 인포윈도우 위치 설정 왜그런지 모르겠지만 Qd, Nd 랜덤으로 뜸
    if (infoWindow.Qd) {
      infoWindow.Qd.width = -6.5;
      infoWindow.Qd.height = -3;
    } else if (infoWindow.Nd) {
      infoWindow.Nd.width = -6.5;
      infoWindow.Nd.height = -3;
    }


    // 마커 클릭 이벤트
    const clickMarker = () => {
      if (document.getElementsByName("closeInfoBtn")[0]) document.getElementsByName("closeInfoBtn")[0].click();
      const level = map.getLevel() >= 7 ? 7 : map.getLevel();
      map.setLevel(level);
      infoWindow.open(map, defaultMarker);
      createInfoWindow(map, defaultMarker, infoWindow, item);
      setMapPosition(parseFloat(item.lat), parseFloat(item.lng), map);
    };

    // 맵 클릭 이벤트
    kakao.maps.event.addListener(defaultMarker, "click", clickMarker);

    return () => {
      kakao.maps.event.removeListener(map);
    };
    
  }

  // 대상자 생년월일
  const getUserBirthday = () => {
    return kendo.toString(dataItem.birthday, "yyyy년 MM월 dd일");
  }

  // 대상자 이미지
  const getUserGenderImg = () => {
    if(dataItem.userGender === "M") {
      return <img className={styles.userGender} src="/images/mobile/icon_man.png"/>
    } else {
      return <img className={styles.userGender} src="/images/mobile/icon_woman2.png"/>
    }
  }

  // 대상자 이벤트
  const getMeainStatTerm = () => {
    if (dataItem.meainStatTerm === "정상") {
      return <span className={styles.element2} style={{color:"#1a6334"}}>{dataItem.meainStatTerm}</span>
    } else if (dataItem.meainStatTerm === "경고") {
      return <span className={styles.element2} style={{color:"#b8a446"}}>{dataItem.meainStatTerm}</span>
    } else if (dataItem.meainStatTerm === "위험") {
      return <span className={styles.element2} style={{color:"#c93e38"}}>{dataItem.meainStatTerm}</span>
    } else if (dataItem.meainStatTerm === "미작동") {
      return <span className={styles.element2} style={{color:"#595858"}}>{dataItem.meainStatTerm}</span>
    } else if (dataItem.meainStatTerm === "설치예정") {
      return <span className={styles.element2} style={{color:"#9e9d9d"}}>미설치</span>
    } else {
      return <span className={styles.element2} style={{color:"#9e9d9d"}}>{dataItem.meainStatTerm}</span>
    }
  }

  // 대상자 상태 지속시간
  const foramtDataStatTime = () => {
    let text = "미작동"
    let hour;
    let min;

    if(dataItem.latestDataStatTime) {
      hour = parseInt(dataItem.latestDataStatTime/60)
      min = dataItem.latestDataStatTime%60

      text = hour + "시간 " + min + "분"
    } else if (dataItem.meainStatCode == '20005') {
      text = "설치예정"
    }
    return <span className={styles.dataStatTime}>{text}</span>;
  }

  // 20001		정상
  // 20002		경고
  // 20003		미작동
  // 20004		위험
  // 20005		설치예정
  // 설비 상태 이미지
  const getMeainStatImg = () => {
    if ( dataItem.meainStatCode === "20001" ) {
      return <img className={styles.eventImg} id="userNormal" src="/images/mobile/normal2.png"/>
    } else if ( dataItem.meainStatCode === "20002" ) {
      return <img className={styles.eventImg}id="userWarn" src="/images/mobile/warn2.png"/>
    } else if ( dataItem.meainStatCode === "20003" ) {
      return ;
    } else if ( dataItem.meainStatCode === "20004" ) {
      return <img className={styles.eventImg} id="userDanger" src="/images/mobile/danger2.png"/>
    } else {
      return ;
    }
  }

  // 10001		고활동
  // 10002		저활동
  // 10003		수면
  // 10004		수면불안
  // 10005		부재
  // 10006		식사
  // 유저 상태 이미지
  const getUserStatImg = () => {

    if ( dataItem.dataStatTerm === '고활동' ) {
      return <img className={styles.statImg} src="/images/mobile/high_activity.png"/>
    } else if ( dataItem.dataStatTerm === '저활동' ) {
      return <img className={styles.statImg} src="/images/mobile/low_activity.png"/>
    } else if ( dataItem.dataStatTerm === '식사' ) {
      return <img className={styles.statImg} src="/images/mobile/meal.png"/>
    } else if ( dataItem.dataStatTerm === '수면' ) {
      return <img className={styles.statImg} src="/images/mobile/sleep.png"/>
    } else if ( dataItem.dataStatTerm === '수면불안' ) {
      return <img className={styles.statImg} src="/images/mobile/sleep.png"/>
    } else if ( dataItem.dataStatTerm === '자리비움' ) {
      if(dataItem.latestDataStatTime < 60) {
        return <img className={styles.statImg} src="/images/mobile/out.png"/>
      } else {
        return <img className={styles.statImg} src="/images/mobile/out.png"/>
      }      
    } else {
      return <img className={styles.statImg} src="/images/mobile/off2.png"/>
    }
  }

  const [temperatureState, setTemperatureState] = useState({
    value: "",
    color: "",
  });
  const [humidityState, setHumidityState] = useState({
    value: "",
    color: "",
  });
  const [co2State, setCo2State] = useState({
    value: "",
    color: "",
  });
  const [tvocState, setTvocState] = useState({
    value: "",
    color: "",
  });

  const getRawDataState = () => {

    const currentDate = new Date();
    const currentMonth = currentDate.getMonth() + 1;

    const sosoColor = "#d6a725";
    const badColor = "#c73a30";
    const smileColor = "#238044";

    if (3 <= currentMonth && currentMonth <= 5) { //봄
      // 온도 (good : 20이상 26미만 / soso : 18이상 20미만, 26이상 30미만 / bad : 18미만, 30이상)
      if ((item.temperature >= 18 && item.temperature < 20) || (item.temperature >= 26 && item.temperature < 30)) {
        setTemperatureState({
          ...temperatureState,
          value: "soso",
          color: sosoColor,
        });
      } else if (item.temperature >= 30 || item.temperature < 18) {
        setTemperatureState({
          ...temperatureState,
          value: "bad",
          color: badColor,
        });
      } else {
        setTemperatureState({
          ...temperatureState,
          value: "smile",
          color: smileColor,
        });
      }
      // 습도 (good : 40이상 60미만 / soso : 30이상 40미만, 60이상 70미만 / bad : 30미만, 70이상)
      if ((item.humidity >= 30 && item.humidity < 40) || (item.humidity >= 60 && item.humidity < 70)) {
        setHumidityState({
          ...humidityState,
          value: "soso",
          color: sosoColor,
        });
      } else if (item.humidity >= 70 || item.humidity < 30) {
        setHumidityState({
          ...humidityState,
          value: "bad",
          color: "#c73a30",
        });
      } else {
        setHumidityState({
          ...humidityState,
          value: "smile",
          color: smileColor,
        });
      }
    } else if (6 <= currentMonth && currentMonth <= 8) { // 여름
      // 온도 (good : 23이상 28미만 / soso : 20이상 23미만, 28이상 32미만 / bad : 20미만, 32이상)
      if ((item.temperature >= 20 && item.temperature < 23) || (item.temperature >= 28 && item.temperature < 32)) {
        setTemperatureState({
          ...temperatureState,
          value: "soso",
          color: sosoColor,
        });
      } else if (item.temperature >= 32 || item.temperature < 20) {
        setTemperatureState({
          ...temperatureState,
          value: "bad",
          color: "#c73a30",
        });
      } else {
        setTemperatureState({
          ...temperatureState,
          value: "smile",
          color: smileColor,
        });
      }
      // 습도 (good : 40이상 60미만 / soso : 30이상 40미만, 60이상 70미만 / bad : 30미만, 70이상)
      if ((item.humidity >= 30 && item.humidity < 40) || (item.humidity >= 60 && item.humidity < 70)) {
        setHumidityState({
          ...humidityState,
          value: "soso",
          color: sosoColor,
        });
      } else if (item.humidity >= 70 || item.humidity < 30) {
        setHumidityState({
          ...humidityState,
          value: "bad",
          color: "#c73a30",
        });
      } else {
        setHumidityState({
          ...humidityState,
          value: "smile",
          color: smileColor,
        });
      }
    } else if (9 <= currentMonth && currentMonth <= 11) { // 가을
      // 온도 (good : 20이상 26미만 / soso : 16이상 20미만, 26이상 30미만 / bad : 16미만, 30이상)
      if ((item.temperature >= 16 && item.temperature < 20) || (item.temperature >= 26 && item.temperature < 30)) {
        setTemperatureState({
          ...temperatureState,
          value: "soso",
          color: sosoColor,
        });
      } else if (item.temperature >= 30 || item.temperature < 16) {
        setTemperatureState({
          ...temperatureState,
          value: "bad",
          color: badColor,
        });
      } else {
        setTemperatureState({
          ...temperatureState,
          value: "smile",
          color: smileColor,
        });
      }
      // 습도 (good : 35이상 60미만 / soso : 30이상 35미만, 60이상 70미만 / bad : 30미만, 70이상)
      if ((item.humidity >= 30 && item.humidity < 35) || (item.humidity >= 60 && item.humidity < 70)) {
        setHumidityState({
          ...humidityState,
          value: "soso",
          color: sosoColor,
        });
      } else if (item.humidity >= 70 || item.humidity < 30) {
        setHumidityState({
          ...humidityState,
          value: "bad",
          color: badColor,
        });
      } else {
        setHumidityState({
          ...humidityState,
          value: "smile",
          color: smileColor,
        });
      }
    } else if (currentMonth === 12 || currentMonth === 1 || currentMonth === 2) { // 겨울
      // 온도 (good : 18이상 25미만 / soso : 14이상 18미만, 25이상 28미만 / bad : 14미만, 28이상)
      if ((item.temperature >= 14 && item.temperature < 18) || (item.temperature >= 25 && item.temperature < 28)) {
        setTemperatureState({
          ...temperatureState,
          value: "soso",
          color: sosoColor,
        });
      } else if (item.temperature >= 28 || item.temperature < 14) {
        setTemperatureState({
          ...temperatureState,
          value: "bad",
          color: badColor,
        });
      } else {
        setTemperatureState({
          ...temperatureState,
          value: "smile",
          color: smileColor,
        });
      }
      // 습도 (good : 30이상 50미만 / soso : 20이상 30미만, 50이상 60미만 / bad : 20미만, 60이상)
      if ((item.humidity >= 20 && item.humidity < 30) || (item.humidity >= 50 && item.humidity < 60)) {
        setHumidityState({
          ...humidityState,
          value: "soso",
          color: sosoColor,
        });
      } else if (item.humidity >= 60 || item.humidity < 20) {
        setHumidityState({
          ...humidityState,
          value: "bad",
          color: badColor,
        });
      } else {
        setHumidityState({
          ...humidityState,
          value: "smile",
          color: smileColor,
        });
      }
    }

    // co2 (good : 1000미만 / soso : 1000이상 2000미만 / bad : 2000 초과 )
    if(item.co2 >= 1000 && item.co2 < 2000) {
      setCo2State({
        ...co2State,
        value: "soso",
        color: sosoColor,
      });
    } else if (item.co2 > 2000) {
      setCo2State({
        ...co2State,
        value: "bad",
        color: badColor,
      });
    } else {
      setCo2State({
        ...co2State,
        value: "smile",
        color: smileColor,
      });
    }
    // tvoc (good : 200미만 / soso : 200이상 1000미만 / bad : 1000 초과 )
    if(item.tvoc >= 200 && item.tvoc < 1000) {
      setTvocState({
        ...tvocState,
        value: "soso",
        color: sosoColor,
      });
    } else if (item.tvoc > 1000) {
      setTvocState({
        ...tvocState,
        value: "bad",
        color: badColor,
      });
    } else {
      setTvocState({
        ...tvocState,
        value: "smile",
        color: smileColor,
      });
    }
  }

  const currentDate = new Date(); // Current date and time
  const oneWeekAgo = new Date(); // Date object for one week ago
  oneWeekAgo.setDate(currentDate.getDate() - 7);

  // 대상자 알림 이력 페이지 이동
  const goAlertLogPage = () => {
    console.log("대상자 알림 이력 페이지 이동");
    history.push({
      pathname: "/log/alert",
      state: { dongCode, dongTermSimple, elderTerm, elderId, startDtm:oneWeekAgo, endDtm:new Date()},
      // state: { dongCode, dongTermSimple, elderTerm, elderId, startDtm, endDtm, eventType, eventTypeTerm },
      // state: { cid, rgnCode, rgnTermSimple, dongCode, dongTermSimple, elderTerm, elderId, startDtm, endDtm, radio },
    });
  }
  // 대상자 정보 페이지 이동
  const goElderInfoPage = () => {
    history.push({
      pathname: "/log/elder",
      state: { cid, rgnCode, rgnTermSimple, dongCode, dongTermSimple, elderTerm, elderId, startDtm, endDtm, radio },
    });
    console.log("대상자 정보 페이지 이동");
  }

  const userPhoto = () => {
    if(item.fileIdUserPhoto) {
      getFile(conn, item.fileIdUserPhoto)
      .then(fileResponse => {
        const dataUri = 'data:image/png;base64,' + fileResponse;
        setImgFile((imgFile) => {
          const item = { ...imgFile};
          item.imgFileUserPhoto = dataUri;
          return item;
        });
        setDataItem((dataItem) => {
          const item = { ...dataItem };
          item.imgFileUserPhoto = dataUri;
          return item;
        })
      })
      .catch(err => {
        console.log("getFile err = ", err);
      })
    }
    if(item.fileIdPlacePhoto1) {
      getFile(conn, item.fileIdPlacePhoto1)
      .then(fileResponse => {
        const dataUri = 'data:image/png;base64,' + fileResponse;
        setImgFile((imgFile) => {
          const item = { ...imgFile};
          item.imgFilePlacePhoto1 = dataUri;
          return item;
        });
        setDataItem((dataItem) => {
          const item = { ...dataItem };
          item.imgFilePlacePhoto1 = dataUri;
          return item;
        })
      })
      .catch(err => {
        console.log("getFile err = ", err);
      })
    } 
    if(item.fileIdPlacePhoto2) {
      getFile(conn, item.fileIdPlacePhoto2)
      .then(fileResponse => {
        const dataUri = 'data:image/png;base64,' + fileResponse;
        setImgFile((imgFile) => {
          const item = { ...imgFile};
          item.imgFilePlacePhoto2 = dataUri;
          return item;
        });
        setDataItem((dataItem) => {
          const item = { ...dataItem };
          item.imgFilePlacePhoto2 = dataUri;
          return item;
        })
      })
      .catch(err => {
        console.log("getFile err = ", err);
      })
    } 
  }

  useEffect(() => {
    userPhoto();
    getRawDataState();
    setDataItem(item);
  }, [item]);


  return (
    <div className={styles.allStatusItem} onClick={findUserInfo}>
      <div className={styles.allStatusItemContainer}>
        <div className={styles.allStatusItemLeft}>
          <div className={styles.allStatusItemLeftTop}>
            {item.fileIdUserPhoto ?
              <img className={styles.userPhoto} src={imgFile.imgFileUserPhoto} alt="사진" />
              :
              <img className={styles.userPhoto} src="/images/mobile/photo.png" alt="사진" />
            }
          </div>
          <div className={styles.allStatusItemLeftBottom}>
            <span className={styles.userTerm}><b>{dataItem.userTerm}({dataItem.dongTermSimple})</b></span>
            <span className={styles.userBirthday}>{getUserBirthday()}{getUserGenderImg()}</span>
          </div>
        </div>
        <div className={styles.allStatusItemMiddle}>
          <div className={styles.allStatusItemMiddleTop}>
            {getMeainStatTerm()}
            {
              dataItem.dangerYn === "Y" && <span style={{marginLeft: "10px"}} className={styles.element1}>관리대상자</span>
            }
            <br/>
            <br/>
          </div>
          <div className={styles.allStatusItemMiddleMiddle}>
            {dataItem.meainStatTerm !== "미작동" &&
            <>
              <span className={styles.dataStatTerm}>{dataItem.dataStatTerm} 상태</span>
              {/* <button className={styles.infoButton} onClick={elderLogBtnClickEvt}><img src="/images/info_white.png"></img></button> */}
              <span className={styles.dataStatTerm}>{foramtDataStatTime()} 입니다.</span>
              {(dataItem.dataStatTerm === "자리비움" && dataItem.behaviorCode && dataItem.behaviorCode !== "B00") &&
                <span className={styles.predictBehavior}>{dataItem.behaviorTerm} 외출 예상</span>
              }
              {(dataItem.dataStatTerm === "자리비움" && dataItem.behaviorCode && dataItem.behaviorCode === "B00") &&
                <span className={styles.predictBehavior}>{dataItem.behaviorTermOther} 외출 예상</span>
              }
            </>
            }
          </div>
          <div className={styles.allStatusItemMiddleBottom}>
            <button className={styles.pageMoveBtn} onClick={goElderInfoPage}><img style={{width: "40px", height: "40px"}} src="/images/information.png"></img></button>
            <button className={styles.pageMoveBtn} onClick={goAlertLogPage}><img style={{width: "40px", height: "40px"}} src="/images/notification.png"></img></button>
            {/* {getMeainStatImg()}
            {getUserStatImg()} */}
          </div>
        </div>
        <div className={styles.allStatusItemRight}>
          {(dataItem.meainStatTerm !== "미작동"  && dataItem.meainStatTerm !== "설치예정") ?
          <>
          <div className={styles.allStatusItemRight1}>
            <div className={styles.allStatusItemRight11}>
              <div className={styles.allStatusItemRight111}>
                <div className={styles.rawDataName}>온도</div>
                <span className={styles.rawDataValue} style={{color: temperatureState.color}}>{numFormat(dataItem.temperature)}</span><span className={styles.rawDataName}>°C</span>
              </div>
              <div className={styles.allStatusItemRight112}>
                <img className={styles.rawDataImg} src={`/images/${temperatureState.value}.png`}/>
              </div>
            </div>
            <div className={styles.allStatusItemRight12}>
              <div className={styles.allStatusItemRight121}>
                <div className={styles.rawDataName}>습도</div>
                <span className={styles.rawDataValue} style={{color: humidityState.color}}>{numFormat(dataItem.humidity)}</span><span className={styles.rawDataName}>%</span>
              </div>
              <div className={styles.allStatusItemRight122}>
                <img className={styles.rawDataImg} src={`/images/${humidityState.value}.png`}/>
              </div>
            </div>
          </div>
          <div className={styles.allStatusItemRight2}>
            <div className={styles.allStatusItemRight21}>
              <div className={styles.allStatusItemRight211}>
                <div className={styles.rawDataName}>이산화탄소</div>
                <span className={styles.rawDataValue} style={{color: co2State.color}}>{numFormat(dataItem.co2)}</span><span className={styles.rawDataName}>ppm</span>
              </div>
              <div className={styles.allStatusItemRight212}>
                {dataItem.bizType !== "5001" &&
                  <img className={styles.rawDataImg} src={`/images/${co2State.value}.png`}/>
                }
              </div>
            </div>
            <div className={styles.allStatusItemRight22}>
              <div className={styles.allStatusItemRight221}>
                <div className={styles.rawDataName}>공기질</div>
                <span className={styles.rawDataValue} style={{color: tvocState.color}}>{numFormat(dataItem.tvoc)}</span><span className={styles.rawDataName}>ppb</span>
              </div>
              <div className={styles.allStatusItemRight222}>
                {dataItem.bizType !== "5001" &&
                  <img className={styles.rawDataImg} src={`/images/${tvocState.value}.png`}/>
                }
              </div>
            </div>
          </div>
          </>
          :<div className={styles.noDataDiv}>장비의 전원을 연결해주세요.</div>}
        </div>
      </div>
    </div>
  );
};
export default AllStatusItem;
